import EmailConfirmationFailure from './EmailConfirmationFailure';

export default EmailConfirmationFailure;
